import React from 'react';
import TierPicker from './TierPicker';

/**
 * ModelSelection — step 2 of the wizard.
 *
 * Replaced the full AI Toolkit page (per-capability model picker) with a
 * simple quality-tier picker (Economy / Standard / Premium) in Mar 2026.
 * TierPicker builds the `selectedModels` map from the chosen tier and
 * persists it to localStorage; downstream code paths (aiService,
 * videoPayloadBuilder, Storyboard shot stamping) read from that same key
 * so they're unaffected by the UI swap.
 */
export const ModelSelection = ({ initialData, onSubmit, onBack }) => {
    const handleContinue = (selectedModels) => {
        onSubmit({ ...initialData, selectedModels });
    };

    return (
        <TierPicker
            duration={initialData?.duration}
            onContinue={handleContinue}
            onBack={onBack}
        />
    );
};
